import { memo } from 'react'
import { BeatLoader } from 'react-spinners'

import css from './button.module.scss'
import { ButtonSizeType, IButton } from './button.type'


/** Кнопка */
export default memo(({ id, name, type = 'button', variant = 'primary', size, width, maxWidth, padding, isDisabled, children, onClick, isLoading = false }: IButton) => {
    const getSizeClassName = (size?: ButtonSizeType) => {
        switch (size) {
            case 'lg': return css.lg
            case 'md': return css.md
            case 'sm': return css.sm
            case 'xs': return css.xs
            default: return css.md
        }
    }

    return (
        <div className={css.buttonWrapper}>
            <button id={id} name={name} type={type} disabled={isDisabled} onClick={onClick} className={`${css[variant]} ${getSizeClassName(size)}`} style={{ width: width, maxWidth: maxWidth, padding: padding }}>
                {children}
            </button>
            {isLoading && <div className={css.isLoading}><BeatLoader size={10} loading={isLoading} color='#f34e2e' /></div>}
        </div>
    )
})